import { RerunReasonsEnum } from '@cambridgeassessment/lib-ee-commons';

export interface AlgoRerunSelect {
  key: RerunReasonsEnum;
  val: string;
}

export const reasonsSelectValues: AlgoRerunSelect[] = [
  {
    key: RerunReasonsEnum.MARKS_GRADES,
    val: resolveRerunReasonText(RerunReasonsEnum.MARKS_GRADES),
  },
  {
    key: RerunReasonsEnum.GROUP_DATA,
    val: resolveRerunReasonText(RerunReasonsEnum.GROUP_DATA),
  },
  {
    key: RerunReasonsEnum.CONSORTIUM_ARRANGEMENTS,
    val: resolveRerunReasonText(RerunReasonsEnum.CONSORTIUM_ARRANGEMENTS),
  },
  {
    key: RerunReasonsEnum.SPECIAL_CONSIDERATIONS,
    val: resolveRerunReasonText(RerunReasonsEnum.SPECIAL_CONSIDERATIONS),
  },
  {
    key: RerunReasonsEnum.OTHER,
    val: resolveRerunReasonText(RerunReasonsEnum.OTHER),
  },
];

export function resolveRerunReasonText(type: RerunReasonsEnum): string {
  const reasonsStrings: {
    [key in RerunReasonsEnum]: string;
  } = {
    MARKS_GRADES: 'Late changes to marks/grades',
    CONSORTIUM_ARRANGEMENTS: 'Late changes to consortium arrangements',
    GROUP_DATA: 'Late changes to teaching group data',
    SPECIAL_CONSIDERATIONS: 'Significant changes to Special Considerations',
    OTHER: 'Other',
  };

  return reasonsStrings[type];
}
